import React from 'react';

const Footer = () => {
    return (
        <>
            <footer className="bg-light text-dark text-center p-3">
                <p>All Right Reserved by Football Club &copy; Chattogram</p>
            </footer>
        </>
    );
};

export default Footer;